import { useCallback } from "react";

import useAddColumnToNormalizationMutation from "queries/commissions/useAddColumnToNormalizationMutation";

import { getMappedAddColumnToNormalizationForm } from "./getMappedAddColumnToNormalizationForm";

type AddColumnToNormalizationProps = {
	mutate: Function;
	isLoading?: boolean;
};

const useAddColumnToNormalization = ({
	onSuccess,
	submitService,
}: {
	onSuccess: Function;
	submitService: Function;
}) => {
	const { mutate: submitAdd }: AddColumnToNormalizationProps =
		useAddColumnToNormalizationMutation({
			onSuccess,
			submitService,
		});

	return useCallback(
		async function submitPage(formValues, entityId) {
			const data = getMappedAddColumnToNormalizationForm(formValues);

			submitAdd({
				data,
				id: entityId,
			});
		},
		[submitAdd],
	);
};

export default useAddColumnToNormalization;
